import FieldProto from "../../proto/field-proto";
import ListComponent from './render/list-read-only';

export default class GenericStringField extends FieldProto {

    constructor(fieldConfig) {
        super(fieldConfig);

        this.type = gd.const.fields.type.GENERIC_STRING;

        this.fieldId = _.get(fieldConfig,'fieldId'); // init field ID
        if (!this.fieldId) console.error("GenericStringField constructor: no fieldId", fieldConfig);

        this.label = _.get(fieldConfig,'label', this.fieldId);  // field label
        this.defaultWidth = _.get(fieldConfig,'defaultWidth', 200) // default column width

        this.isSearchable = true;
    }

    sortValue(value) {
        return value ? value.toLowerCase() : '';
    }

    searchValue(value) {
        return value ? value.toLowerCase() : '';
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }

    // get GListValue() {
    //     return ListComponent.bind(null);
    // }

    get ViewComponent() {
        return ListComponent.bind(null);
    }
}
